/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const createContactHeaderParamsSchema = z.object({
    "x-radar-user-id": z.optional(z.string().describe("Contact owner id — required when authenticating with the service secret instead of a bearer token"))
    }).optional()

/**
 * @description Contact created
 */
export const createContact201Schema = z.object({
    "id": z.string(),
"userId": z.string(),
"externalId": z.nullable(z.string()),
"name": z.nullable(z.string()),
"title": z.nullable(z.string()),
"email": z.nullable(z.string()),
"phone": z.nullable(z.string()),
"company": z.nullable(z.string()),
"location": z.nullable(z.string()),
"socialMedia": z.nullable(z.object({
    
    }).catchall(z.string())),
"createdAt": z.iso.datetime(),
"updatedAt": z.iso.datetime()
    })

/**
 * @description Invalid body
 */
export const createContact400Schema = z.any()

/**
 * @description Contact limit reached (body.code = \"contact-limit-reached\")
 */
export const createContact403Schema = z.any()

export const createContactMutationRequestSchema = z.object({
    "name": z.optional(z.string()),
"title": z.optional(z.string()),
"email": z.optional(z.string()),
"phone": z.optional(z.string()),
"company": z.optional(z.string()),
"location": z.optional(z.string()),
"socialMedia": z.optional(z.object({
    
    }).catchall(z.string())),
"externalId": z.optional(z.uuid())
    })

export const createContactMutationResponseSchema = z.lazy(() => createContact201Schema)